import React, { useEffect, useState } from "react";
import { FiLogOut } from "react-icons/fi";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ExpenseHeader from "../ExpenseDashboard/ExpenseHeader";
import { identity } from "lodash";

const AddExpense = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [billImage, setBillImage] = useState(null);
  const [loading, setLoading] = useState(false);

 const [users, setUsers] = useState([]);
 const id = localStorage.getItem("id");
  const [formData, setFormData] = useState({
    date: "",
    category: "",
    project: "",
    person: id,
    supplier: "",
    invoice_value: "",
    total_cost: "",
    remarks: "",
    payment_status: "unpaid",
  });

  useEffect(() => {
  if (!id) {
    navigate("/login");
  }
}, [id, navigate]);

 const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://api.hanoch.in/users/clients/?role=automation&is_active=true");
      setUsers(res.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://api.hanoch.in/expense/categories/");
        setCategories(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to fetch categories");
      }
    };
    fetchCategories();
  }, []);

  // 🔹 Fetch projects
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get("https://api.hanoch.in/expense/project_categories/");
        setProjects(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Error fetching projects:", error);
        toast.error("Failed to fetch projects");
      }
    };
    fetchProjects();
  }, []);

  // 🔹 Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Handle file upload
// 🔹 Handle file upload (detect image or PDF)
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];

  if (!validTypes.includes(file.type)) {
    toast.warning("Only JPG, PNG, or PDF files are allowed!");
    e.target.value = null;
    return;
  }

  setBillImage(file);
};


  // 🔹 Submit form to backend
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.date || !formData.category || !formData.project || !formData.total_cost) {
    toast.warning("Please fill all required fields");
    return;
  }

  setLoading(true);
  const payload = new FormData();

  payload.append("date", formData.date);
  payload.append("category", formData.category);
  payload.append("project", formData.project);
  payload.append("supplier", formData.supplier);
  payload.append("invoice_value", formData.invoice_value);
  payload.append("total_cost", formData.total_cost);
  payload.append("remarks", formData.remarks);
  payload.append("payment_status", formData.payment_status);
 payload.append("person",formData.person);
  // ✅ Map the user name to their ID before sending
  


  if (billImage) payload.append("bill_image", billImage);

  try {
    await axios.post("https://api.hanoch.in/expense/", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    toast.success("✅ Expense added successfully!");
    navigate("/ExpenseDashboard");
  } catch (err) {
    console.error("Error adding expense:", err.response?.data || err);
    toast.error("❌ Failed to add expense");
  } finally {
    setLoading(false);
  }
};


 

  return (
    <div className="dashboard-container">
      {/* Header */}
      <ExpenseHeader/>
      {/* Add Expense Form */}
     <Container className="p-4">
  <Row className="justify-content-center">
    <Col lg="6" md="8" sm="10">
      {/* <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
        <Button
          color="success"
          onClick={() => navigate("/addExpenseUser")}
        >
          +User
        </Button>
        <Button
          color="success"
          onClick={() => navigate("/addExpenseCategory")}
        >
          +Category
        </Button>
        <Button
          color="success"
          onClick={() => navigate("/addProject")}
        >
          +Project
        </Button>
      </div> */}
   


           

            <Card className="shadow-sm border-0">
              <CardBody>
                <CardTitle tag="h5" className="mb-4 text-center">
                 <h4> Add New Expense</h4>
                </CardTitle>

                <Form onSubmit={handleSubmit}>
                  {/* Date */}
                  <FormGroup className="mb-3">
                    <Label>Date</Label>
                    <Input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>


                  {/* Project */}
                  <FormGroup className="mb-3">
                    <Label>Project</Label>
                    <Input
                      type="select"
                      name="project"
                      value={formData.project}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Project</option>
                      {projects.map((proj) => (
                        <option key={proj.id} value={proj.id}>
                          {proj.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  {/* Category */}
                  <FormGroup className="mb-3">
                    <Label>Category</Label>
                    <Input
                      type="select"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  {/* Supplier */}
                  <FormGroup className="mb-3">
                    <Label>Supplier</Label>
                    <Input
                      type="text"
                      name="supplier"
                      placeholder="Enter supplier name"
                      value={formData.supplier}
                      onChange={handleChange}
                    />
                  </FormGroup>

                  {/* Invoice Value */}
                  <FormGroup className="mb-3">
                    <Label>Invoice Value (₹)</Label>
                    <Input
                      type="number"
                      name="invoice_value"
                      placeholder="Enter invoice value"
                      value={formData.invoice_value}
                      onChange={handleChange}
                    />
                  </FormGroup>

                  {/* Total Cost */}
                  <FormGroup className="mb-3">
                    <Label>Total Cost (₹)</Label>
                    <Input
                      type="number"
                      name="total_cost"
                      placeholder="Enter total cost"
                      value={formData.total_cost}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>

                  {/* Remarks */}
                  <FormGroup className="mb-3">
                    <Label>Remarks</Label>
                    <Input
                      type="text"
                      name="remarks"
                      placeholder="Enter remarks"
                      value={formData.remarks}
                      onChange={handleChange}
                    />
                  </FormGroup>

                  {/* Bill Image */}
                 <FormGroup className="mb-4">
  <Label>Attach Bill Image / PDF</Label>
  <Input
    type="file"
    accept="image/*,application/pdf"
    onChange={handleFileChange}
  />
  {billImage && (
    <p className="mt-2 text-muted" style={{ fontSize: "0.9rem" }}>
      Selected file: {billImage.name}
    </p>
  )}
</FormGroup>


                  <div className="text-center">
                    <Button color="primary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner size="sm" /> Saving...
                        </>
                      ) : (
                        "Add Expense"
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddExpense;
